import { useJsApiLoader } from '@react-google-maps/api';

/**
 * The one way to load the Google Maps script.
 *
 * The loader is a page-wide singleton: a second caller asking for different libraries (or a
 * different id) throws "Loader must not be called again with different options". Every map in
 * the app therefore loads through these two constants, so they cannot drift apart.
 */
export const GOOGLE_MAPS_LIBRARIES: ('places' | 'geometry')[] = ['places', 'geometry'];

/** The default id @react-google-maps uses, kept so existing useLoadScript callers share one script. */
export const GOOGLE_MAPS_SCRIPT_ID = 'script-loader';

export const GOOGLE_MAPS_API_KEY: string = process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '';

export interface GoogleMapsState {
  isLoaded: boolean;
  loadError: Error | undefined;
  /** False when no key is configured: the caller shows a notice instead of a broken map. */
  hasKey: boolean;
}

export function useGoogleMaps(): GoogleMapsState {
  const { isLoaded, loadError } = useJsApiLoader({
    id: GOOGLE_MAPS_SCRIPT_ID,
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });
  return { isLoaded, loadError, hasKey: GOOGLE_MAPS_API_KEY.trim().length > 0 };
}
